import React, {  useState} from 'react';
import {Button } from "react-bootstrap";
import {  Container,Row,Col  } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form} from 'semantic-ui-react';

import styled from "styled-components"; 
import DeviceUtils from "../../helper/DeviceUtils";
import Spinner from "../common/Spinner";
import ApiUtils from "../../helper/ApiUtils"; 

 
 
const Centeryellow =  styled.div` 
    min-width: 980px;
    width: calc(100% - 190px - 190px);
    height: 568px;
    color:white;
    padding-top: ${props => props.paddingTop}px;
    background-color: #000000;
    height: ${props => props.height}px;
    position: relative; 
    padding: 0px;
    margin-left: auto;
    margin-right: auto;`;

 
const FormWrap =  styled.div`  
    width: ${props => props.width}px; 
    `;
    
const ContactView = () => {

    const [UserName,setUserName] = useState("");
    const [Email,setEmail] = useState("");
    const [Message,setMessage] = useState("");
    const [Subject,setSubject] = useState(""); 
    const [loading,setloading] = useState(""); 
 
    const isValidEmailAddress = (address)=> {
        return !! address.match(/.+@.+/);
    }


    const inputWidth = (DeviceUtils.isMobile()===true)?(window.innerWidth - 15):152;


    const [MessageError,setMessageError] = useState(false);
    const [EmailError,setEmailError] = useState(false);
    const [UserNameError,setUserNameError] = useState(false);
    const [SubjectError,setSubjectError] = useState(false);

 
    const Cinput = ({ }) => {  
        return <Form.Field
        style={{ 
            backgroundColor: "black",
            width: `${inputWidth}px`,
            borderTop: "none",
            borderLeft: "none",
            borderRight: "none",
            borderBottom: "1px solid white",
            color:"white"
        }}
                        className={(DeviceUtils.isMobile()===true)?" Cinput":" Cinput"}
                        error={(SubjectError===true)?{
                            content: 'Subject Required',
                            pointing: (DeviceUtils.isMobile()===true)?'below':'below',
                        }:null}
                        control="input" 
                        value={Subject}
                        onChange={(event)=>{
                            setSubject(event.target.value);

                            if(Subject!==''){
                                setSubjectError(false);
                            }
                        }}
                    /> 
        };

    return <Centeryellow id="ContactView"   >
        <FormWrap

        width={(DeviceUtils.isMobile()===true)?window.innerWidth:568}
        style={{
            paddingTop:`${DeviceUtils.isMobile()===true?35:0}px`,
            paddingLeft:`${DeviceUtils.isMobile()===true?20:0}px`
        }} > 

        <Row>
            <Col>
                <label className="contactPageP">Subject</label>
                {/* <Cinput /> */}

                <Form.Field
        style={{ 
            backgroundColor: "black",
            width: `${inputWidth}px`,
            borderTop: "none",
            borderLeft: "none",
            borderRight: "none",
            borderBottom: "1px solid white",
            color:"white"
        }}
                        className={(DeviceUtils.isMobile()===true)?" Cinput":" Cinput"}
                        error={(SubjectError===true)?{
                            content: 'Subject Required',
                            pointing: (DeviceUtils.isMobile()===true)?'below':'below',
                        }:null}
                        control="input" 
                        value={Subject}
                        onChange={(event)=>{
                            setSubject(event.target.value);

                            if(Subject!==''){
                                setSubjectError(false);
                            }
                        }}
                    /> 
            </Col> 
            <Col>

                <label className="contactPageP">Name</label>
                <Form.Field
                style={{ 
                    backgroundColor: "black",
                    width: `${inputWidth}px`,
                    borderTop: "none",
                    borderLeft: "none",
                    borderRight: "none",
                    borderBottom: "1px solid white",
                    color:"white"
                }}
                                className={(DeviceUtils.isMobile()===true)?"  mb-1":"  mb-1"}
                                error={(UserNameError===true)?{
                                    content: 'Name Required',
                                    pointing: (DeviceUtils.isMobile()===true)?'below':'below',
                                }:null}
                                control="input" 
                                value={UserName}
                                onChange={(event)=>{
                                    setUserName(event.target.value);

                                    if(UserName!==''){
                                        setUserNameError(false);
                                    }
                                }}
                            />
            </Col>
            <Col>
                <label className="contactPageP">Email*</label>
                <Form.Field
                style={{ 
                    backgroundColor: "black",
                    width: `${inputWidth}px`,
                    borderTop: "none",
                    borderLeft: "none",
                    borderRight: "none",
                    borderBottom: "1px solid white",
                    color:"white"
                }}
                                className={(DeviceUtils.isMobile()===true)?" mb-1":"  mb-1"}
                                error={(EmailError===true)?{
                                    content: 'Email Required',
                                    pointing: (DeviceUtils.isMobile()===true)?'below':'below',
                                }:null}
                                control="input"  
                                value={Email}
                                onChange={(event)=>{
                                    setEmail(event.target.value);

                                    if(Email!==''){
                                        setEmailError(false);
                                    }
                                }} 
                            />
            </Col> 
        </Row>
        <Row>
            <Col>
                <label className="contactPageP pt-5">Leave us a message...</label> 
                <Form.Field
                style={{ 
                    backgroundColor: "black",
                    width: `${568}px`,
                    borderTop: "none",
                    borderLeft: "none",
                    borderRight: "none",
                    borderBottom: "1px solid white",
                    color:"white"
                }}
                                    className={(DeviceUtils.isMobile()===true)?" ":" "}
                                    error={(MessageError===true)?{
                                        content: 'Message Required',
                                        pointing: (DeviceUtils.isMobile()===true)?'below':'below',
                                    }:null}
                                    control="textarea"
                                    rows="3"  
                                    value={Message}
                                    onChange={(event)=>{
                                        setMessage(event.target.value);

                                        if(Message!==''){
                                            setMessageError(false);
                                        }
                                    }}
                                />
            </Col> 
        </Row>
        <Row>
            <Col>
            {(loading===true)?<Spinner/>:<button
                            className="mt-5 py-2 px-4 mainYellowBg border border-white"
                          
                            onClick={async ()=>{

                            const emailIsValid =  isValidEmailAddress(Email);


                            if(UserName===''){
                                setUserNameError(true);
                            }else{
                                setUserNameError(false);
                            }
                            if(Subject===''){
                                setSubjectError(true);
                            }else{
                                setSubjectError(false);
                            }
                            if(Message===''){
                                setMessageError(true);
                            }else{
                                setMessageError(false);
                            }
                            if(Email===''){
                                setEmailError(true);
                            }else{
                                setEmailError(false);
                            }

                            if(emailIsValid===false){
                                setEmailError(true);
                                // alert('Need email');
                                return;
                            }


                            if(UserName==='' || Subject==='' || Message==='' || Email===''){
                                return;
                            }

                            await setloading(true);
                            //新增
                            await ApiUtils.post_sql(`${ApiUtils.post_homeContactusMail}`,{
                                "fromType":2,
                                "UserName":UserName,
                                "Email":Email,
                                'Subject':Subject,
                                "Message":Message
                            });
                            setEmail('');
                            setMessage('');
                            setSubject('');
                            setUserName('');

                            alert('Message has been sent');

                            await setloading(false);

                        }} ><b>Submit</b></button>}
            </Col>
        </Row>
        
            
          <Form size={"tiny"}>  

            </Form>
    
        </FormWrap>
    </Centeryellow>;
};

export default ContactView;



// WEBPACK FOOTER //
// ./src/components/homepage_new/ContactView.js